import {
  apiDelete,
  apiGet,
  apiGetById,
  apiPost,
  apiPut,
  type ApiResponse,
} from "./genesisApi/httpsMethods";
import type {
  CreateDealTaskBody,
  DealTask,
  TaskStatus,
  UpdateDealTaskBody,
} from "../types/dealTask";

export async function getDealTasks(
  dealId: number,
): Promise<ApiResponse<DealTask[]>> {
  return apiGetById<DealTask[]>("deal-tasks", dealId);
}

export async function getAssignedTasks(
  userId: number,
  status?: TaskStatus,
): Promise<ApiResponse<DealTask[]>> {
  const queryParams = status ? { status } : undefined;
  return apiGet<DealTask[]>(`deal-tasks/assigned/${userId}`, queryParams);
}

export async function createDealTask(
  dealId: number,
  body: CreateDealTaskBody,
): Promise<ApiResponse<DealTask>> {
  return apiPost<DealTask>(`deal-tasks/${dealId}`, body);
}

export async function updateDealTask(
  taskId: number,
  body: UpdateDealTaskBody,
): Promise<ApiResponse<{ message: string }>> {
  return apiPut<{ message: string }>("deal-tasks", taskId, body);
}

export async function deleteDealTask(
  taskId: number,
): Promise<ApiResponse<null>> {
  return apiDelete<null>("deal-tasks", taskId);
}
